import React from 'react';

const TEMPLATES = [
  { id: 'blank', name: 'Blank Form', icon: '📄', description: 'Start from scratch — add fields and build your own layout', category: 'blank' },
  { id: 'tpl_contact', name: 'Contact Form', icon: '👤', description: 'Pre-wired for contacts — fully customizable: reorder, resize, add/remove fields', category: 'contact' },
  { id: 'tpl_company', name: 'Company Form', icon: '🏢', description: 'Pre-wired for companies — fully customizable: reorder, resize, add/remove fields', category: 'company' },
  { id: 'tpl_contact_company', name: 'Contact + Company', icon: '🔗', description: 'Pre-wired for both contacts and companies — fully customizable', category: 'contact_company' },
];

export default function FormTemplateGallery({ open, onClose, onChoose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full p-6">
        <h2 className="text-xl font-bold mb-1">Choose a Template</h2>
        <p className="text-sm text-gray-500 mb-2">Start with a pre-wired template — you can fully customize everything afterward.</p>
        <p className="text-xs text-indigo-600 mb-5">Templates pre-fill fields with CRM wiring. You can reorder, resize, add, remove, and restructure any field.</p>
        <div className="grid grid-cols-2 gap-4">
          {TEMPLATES.map((tpl) => (
            <button key={tpl.id} onClick={() => onChoose(tpl)}
              className="text-left p-4 border-2 border-gray-200 rounded-lg hover:border-indigo-500 hover:bg-indigo-50 transition">
              <div className="text-3xl mb-2">{tpl.icon}</div>
              <div className="font-semibold text-gray-900">{tpl.name}</div>
              <div className="text-sm text-gray-500">{tpl.description}</div>
            </button>
          ))}
        </div>
        <div className="mt-5 flex justify-end">
          <button onClick={onClose} className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900">Cancel</button>
        </div>
      </div>
    </div>
  );
}
